import * as React from 'react';
import { CSSProperties } from 'react';
import * as Tgcc from '../tgccGlobal';

type FilterProperties = {
    groupName: string;
    value: any;
    label: string;
    removeFilter: (value: any) => void;
}

type StateType = { expanded: boolean }

export class FilterBubble extends React.Component<FilterProperties, any> {

    bubbleStyle: CSSProperties = {
        marginLeft: '4px',
        marginBottom: '4px',
        textTransform: 'none',
        letterSpacing: 0,
        float: 'left',
        display: 'block',
        backgroundColor: '#58585A',
        color: Tgcc.Styles.paleWhite,
        borderRadius: '8px',
        lineHeight: '12px',
        fontSize: '9px',
        padding: '2px 7px'
    }

    clearStyle: CSSProperties = {
        float: 'right',
        fontSize: '16px',
        marginLeft: '15px',
        cursor: 'pointer'
    }

    contentStyle: CSSProperties = {
        float: 'left',
        clear: 'both',
        display: 'flex',
        flexDirection: 'column',
        lineHeight: '14px',
        fontSize: '12px',
        letterSpacing: 0,
        color: 'white'
    }

    render() {
        var key = this.props.groupName + this.props.value;
        return (
            <div key={key} style={this.bubbleStyle}>
                {this.props.groupName}
                <div onClick={() => this.props.removeFilter(this.props.value)} style={this.clearStyle}>&times;</div>
                <div style={this.contentStyle}>{this.props.label}</div>
            </div>
        )
    }
}
